module.exports = __webpack_public_path__ + "img/customer.0eb4d8ae.png";